export function getStrapiURL(path = "") {
    return `${
        process.env.NEXT_PUBLIC_STRAPI_API_URL || "http://localhost:1337"
    }${path}`;
}

export function getNamecardURL(path = "") {
    return `${
        process.env.NEXT_PUBLIC_NAMECARD_API_URL || "http://localhost:5208"
    }${path}`;
}

export function getStrapiMedia(url: string | null) {
    if (url == null) {
        return "null";
    }

    // Return the full URL if the media is hosted on an external provider
    if (url.startsWith("http") || url.startsWith("//")) {
        return url;
    }

    // Otherwise prepend the URL path with the Strapi URL
    return `${getStrapiURL()}${url}`;
}

export function slugify(str: string) {
    return str
        .toLowerCase()
        .replace(/&/g, "and")
        .replace(/[^\w\s-]/g, "")
        .trim()
        .replace(/\s+/g, "-");
}
